import React from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";

import {featureInterface} from "./featureInterface";
import CheckBox from "../../PageLayout/CheckBox";
import {featuresSetupUpdateFeature} from "../featuresActions";

const FeaturesSetupFeatureSelectedCheckbox = (props) => {

  const {feature, featuresSetupUpdateFeature} = props;

  if (!feature) {
    return null
  }

  const onChecked = (selected) => {
    featuresSetupUpdateFeature(feature, "selected", !selected)
  }

  return (
    <div className="wizard-item__box-checkbox fs-feature__box-checkbox">
      <CheckBox checked={feature.selected}
                innerStyle="none"
                colorClass="dark"
                onChecked={onChecked}
                text=""/>
    </div>
  )
};

FeaturesSetupFeatureSelectedCheckbox.propTypes = {
  feature: PropTypes.shape(featureInterface).isRequired
}

const mapStateToProps = () => {
  return {
  };
};

const mapDispatchToProps = {
  featuresSetupUpdateFeature
};

export default connect(mapStateToProps, mapDispatchToProps)(FeaturesSetupFeatureSelectedCheckbox)
